import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  imageContainer: {
    marginTop: 15,
  },
  title: {
    marginTop: 10,
  },
  iconDimensions: {
    width: 32,
    height: 32,
    marginRight: 8,
  },
  arrowDimensions: {
    width: 32,
    height: 32,
  },
  currentBillStyle: theme => ({
    marginTop: -4,
    fontSize: 16,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
});
